import axiosInstance from '../axios';
import { rejectError, rejectErrorApi } from '../helper';

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    getAccountData() {
      return axiosInstance.get('/user/profile')
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }

          return result.data.profile;
        })
        .catch((error) => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    updateAccount({ dispatch }, account) {
      return axiosInstance.post('/user/profile/update', account)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.profile;
        })
        .catch((error) => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    changePassword({ dispatch }, account) {
      const params = {
        new_password: account.newPassword,
      };
      return axiosInstance.post('/user/profile/update-password', params)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.profile;
        })
        .catch((error) => rejectError(error));
    },
  },
};
